module.exports = __webpack_public_path__ + "static/img/Visualization3.98d18d8d.png";